import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchLiquidationsByDays = (type, year, month) => apiActionCreator({
  'endpoint': `/importations/liquidations/byDays?type=${type}&year=${year}&month=${month}`,
  'authenticated': true,
  'types': [
    ActionTypes.LOADING_LIQUIDATIONS_BY_DAYS,
    ActionTypes.LOADED_LIQUIDATIONS_BY_DAYS,
    [
      ActionTypes.LOADED_LIQUIDATIONS_BY_DAYS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchLiquidationsByDaysDetail = ({type, year, month, day}) => apiActionCreator({
  'endpoint': `/importations/liquidations/byDays/detail?type=${type}&year=${year}&month=${month}&day=${day}`,
  'authenticated': true,
  'types': [
    ActionTypes.LOADING_LIQUIDATIONS_BY_DAY_DETAIL,
    ActionTypes.LOADED_LIQUIDATIONS_BY_DAY_DETAIL,
    [
      ActionTypes.LOADED_LIQUIDATIONS_BY_DAY_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
